export default "__VITE_ASSET__CwWqNTii__"